module.exports = __webpack_public_path__ + "img/sale.8afbb8d0.svg";